import React from 'react';
import { NumericFormat } from 'react-number-format';
import { Col, Container, Modal, ModalBody, Row, Label, Input, Form, FormGroup } from 'reactstrap';
import modalclose from '../../../images/close.png';
import FYearService from '../../../services/FYearService';
import { CommonButton } from '../../CommonComponents';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import './index.css';

const SegmentModal = ({ isModalLoading, isOpen, toggle, editSegmentId, handleSegmentSubmit, segmentName, setSegmentName, segmentYear, segmentTurnOver, setSegmentTurnOver }) => {
    let fYYear = FYearService.getFYear();
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered className="modalSegment" id='modalSegment'>
            {isModalLoading && <CustomSpinner />}
            <ModalBody className='pb-0'>
                <div className="closeButton d-flex justify-content-end mb-3">
                    <img src={modalclose} alt="close" onClick={toggle} className="cursorPointer" />
                </div>
                <div className='modalHeading flex-column'>
                    <div className='title text-capitalize'>Input Wise Last Year Turnover</div>
                </div>
                <div className='bodyArea'>
                    <Container fluid>
                        <Form onSubmit={handleSegmentSubmit}>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label className='common-input-label'>Enter Segment <span className='required'>*</span></Label>
                                        <br />
                                        <div className='select-wrapper'>
                                            <Input
                                                type='select'
                                                autoComplete='off'
                                                required
                                                value={
                                                    segmentName === null || segmentName === 'undefined'
                                                        ? ''
                                                        : segmentName
                                                }
                                                onChange={(e) => setSegmentName(e.target.value)}
                                                disabled={editSegmentId}
                                                style={{ cursor: `${editSegmentId ? 'auto' : 'pointer'}` }}
                                                name='name'
                                                id='select'
                                                placeholder='Type here'
                                            >
                                                <option value={''}>Select</option>
                                                <option value='FERTILISERS'>FERTILISERS</option>
                                                <option value='PESTICIDES'>PESTICIDES</option>
                                                <option value='PGR'>PGR</option>
                                                <option value="WSF'S">WSF'S</option>
                                                <option value='DRIP IRRIGATION SYSTEM'>
                                                    DRIP IRRIGATION SYSTEM
                                                </option>
                                            </Input>
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label className='common-input-label'>
                                            Financial Year&nbsp;
                                            <span className='required'>*</span>
                                        </Label>
                                        <br />
                                        <div className='select-wrapper'>
                                            <Input
                                                type='text'
                                                name='detail'
                                                disabled
                                                value={editSegmentId ? segmentYear : fYYear.prevFinancialYear}
                                                placeholder='Type here'
                                            />
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label className='common-input-label'>
                                            Enter Turnover&nbsp;
                                            <span className='required'>*</span>
                                        </Label>
                                        <br />
                                        <NumericFormat
                                            className='format-number w-100'
                                            type='text'
                                            autoComplete='off'
                                            name='detail'
                                            required
                                            thousandSeparator={true}
                                            thousandsGroupStyle='lakh'
                                            onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }}
                                            value={
                                                segmentTurnOver === null ||
                                                    segmentTurnOver === 'undefined'
                                                    ? ''
                                                    : segmentTurnOver
                                            }
                                            onChange={(e) => setSegmentTurnOver(e.target.value)}
                                            id='detail'
                                            placeholder='Type here'
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className='modalBtn d-flex align-items-center justify-content-center'>
                                        <CommonButton name={editSegmentId ? 'Update' : 'Add'} btnClass={'btnPrimary'} type="submit" />
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Container>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default SegmentModal
